import Collapsible from "react-collapsible";
import { FaHotel } from "react-icons/fa";
import HotelsTable from "./HotelsTable";
import NoHotelsMessage from "./NoHotelsMessage";
import Collabse from "../../../components/Collabse";
import { useTranslation } from "react-i18next";

const Hotels = () => {
  return (
    <Collabse Header={Header}>
      <HotelsTable />
      <NoHotelsMessage />
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();
  return (
    <h5>
      <FaHotel />
      {t("bookingDetails.hotels.title")}
    </h5>
  );
};

export default Hotels;
